import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AiFillStar } from "react-icons/ai";
import { RiBookmark3Fill, RiArrowRightSLine } from "react-icons/ri";
import MainSidebar from "./MainSidebar";
import { useDispatch, useSelector } from "react-redux";
import { setMainMovies, setHeroMovie } from "../../redux/actions/movieActions";
import fullDate from "../DateFunction";
import { addToWatchlist } from "../../redux/actions/movieActions";
import "./Main.scss";

const Main = () => {
  const mainMovie = useSelector((state) => state.heroMovie);
  const dispatch = useDispatch();

  const [releaseDate, setReleaseDate] = useState("");
  const [mainTitle, setMainTitle] = useState("");

  const getNewMoviesRequest = async () => {
    const url = `https://api.themoviedb.org/3/movie/upcoming?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&page=1`;
    // const url = `https://api.themoviedb.org/3/movie/upcoming?api_key=0bae2b774ae975ea338f73141added57&language=en-US&page=1`;
    const newResponse = await fetch(url);
    const newData = await newResponse.json();
    dispatch(setMainMovies(newData.results));
    dispatch(setHeroMovie(newData.results[0]));
    setReleaseDate(fullDate(newData.results[0].release_date));
    setMainTitle(
      newData.results[0].title.length < 35
        ? newData.results[0].title
        : `${newData.results[0].title.substring(0, 35)}...`
    );

    // console.log(url);
  };

  useEffect(() => {
    getNewMoviesRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="hero" id="hero">
      <div className="hero-main">
        <div className="hero-new-header">
          <Link to="/new-movies" className="featured-header-link">
            New Movies{" "}
            <span>
              <RiArrowRightSLine />
            </span>
          </Link>
        </div>
        <section className="main-box">
          <Link to={`/movie/${mainMovie.id}`}>
            <img
              className="main-box-img"
              src={`https://image.tmdb.org/t/p/original${mainMovie.backdrop_path}`}
              alt={mainMovie.title}
            />
            <div className="main-box-img-overlay"></div>
          </Link>
          <div className="main-box-info">
            <div className="main-image-container">
              <RiBookmark3Fill
                className="main-book-icon"
                onClick={() => dispatch(addToWatchlist(mainMovie))}
              />
              <Link to={`/movie/${mainMovie.id}`}>
                <img
                  src={`https://image.tmdb.org/t/p/original${mainMovie.poster_path}`}
                  alt={mainMovie.title}
                  className="main-img"
                />
              </Link>
            </div>
            <div className="main-info-container top-responsive-info-cont">
              <div className="">
                <h1 className="main-title">{mainTitle}</h1>
                {mainMovie.overview && mainMovie.overview.length > 220 ? (
                  <p className="main-plot">
                    {mainMovie.overview.substring(0, 220)}...
                  </p>
                ) : (
                  <p className="main-plot">{mainMovie.overview}</p>
                )}
                <p className="main-date">Released: {releaseDate}</p>
                <div className="main-buttons">
                  <Link to={`/movie/${mainMovie.id}`} className="trailer-link">
                    more details
                  </Link>
                </div>
              </div>
              <div className="main-rating">
                <p>
                  {mainMovie.vote_average} <AiFillStar className="main-star" />
                </p>
              </div>
            </div>
          </div>
        </section>
        <div className="main-info-container responsive-main-info">
          <div className="">
            <h1 className="main-title">{mainTitle}</h1>
            {mainMovie.overview && mainMovie.overview.length > 220 ? (
              <p className="main-plot">
                {mainMovie.overview.substring(0, 220)}...
              </p>
            ) : (
              <p className="main-plot">{mainMovie.overview}</p>
            )}
            <p className="main-date">Released: {releaseDate}</p>
            <div className="main-buttons">
              <Link to={`/movie/${mainMovie.id}`} className="trailer-link">
                more details
              </Link>
            </div>
          </div>
          <div className="main-rating">
            <p>
              {mainMovie.vote_average} <AiFillStar className="main-star" />
            </p>
          </div>
        </div>
      </div>
      <div className="hero-side">
        <Link to="/new-movies" className="hero-side-header">
          New Movies{" "}
          <span className="hero-side-header-span">
            <RiArrowRightSLine />
          </span>
        </Link>
        <div className="hero-movie-list">
          <MainSidebar />
        </div>
      </div>
    </div>
  );
};

export default Main;
